import type { ReportUploadedFile } from "@/api/report/_models/ReportUpload";
import { useSnapshotSection } from "@/components/snapshot/snapshotSection.context";
import { SnapshotDropzoneFileActions } from "./SnapshotDropzoneFileActions";
import { SnapshotDropzoneRow } from "./SnapshotDropzoneRow";
import { toSydneyDateTimeText } from "./snapshotDropzone.utils";

interface SnapshotDropzoneUploadedRowProps {
  file: ReportUploadedFile;
}

/** A row for a file already in S3, with its tags and delete button. */
export const SnapshotDropzoneUploadedRow = (props: SnapshotDropzoneUploadedRowProps) => {
  const { file } = props;
  const section = useSnapshotSection();
  const isConfirming = section.deletion.file?.key === file.key;

  return (
    <SnapshotDropzoneRow
      action={<SnapshotDropzoneFileActions file={file} />}
      actionKey={isConfirming ? "confirm" : "actions"}
      name={file.filename}
      size={file.size}
      status={`uploaded ${toSydneyDateTimeText(file.uploadedAt)}`}
      title={file.key}
    />
  );
};
